import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	username: '',
	pin: '',
	password: '',
};

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		resetState: () => initialState,
		setUsername: (state, action) => {
			const { payload: username = initialState.username } = action;
			state.username = username;
		},
		setPin: (state, action) => {
			const { payload: pin = initialState.pin } = action;
			state.pin = pin;
		},
		setPassword: (state, action) => {
			const { payload: password = initialState.password } = action;
			state.password = password;
		},
	},
});
